// Vendor Libs
import React from 'react';
import {get, map} from 'lodash';
import PropTypes from 'prop-types';

// Components
import Loading from '../core/loading';
import Permissions from '../core/permissions';
import RecordDetails from '../core/record-details';
import ServicesRefreshPanelAction from '../app/services-refresh-panel-action';

// Containers
import withSearch from '../../containers/with-search';

// Styles
import './health.scss';

const servicesDataKey = 'health';

function Health({ servicesSearchData: { searchData }, fetching }) {
  const formatClassNameStatus = (status) => status.toLowerCase().replace(/_|\s/g, '-');

  const renderEnvironmentHealth = () => (fetching ? (
            <Loading loading={fetching} />
        ) : (
            <div className="health--environment">
                <div className="health--environment-status-display">
                    {renderEnvironmentOverallHealthStatus()}
                    <div className="health--environment-status-item">{renderEnvironmentFieldStatus()}</div>
                </div>
                {renderEnvronmentHealthDetails()}
            </div>
        ));

  const renderEnvronmentHealthDetails = () => (!searchData ? null : (
            <div className="health--environment-details-display">
                <div className="health--environment-display-header">
                    <label>Environment Details</label>
                </div>
                <RecordDetails
                    className="health--environment-details-field"
                    noTitleFormatting={true}
                    searchData={[searchData]}
                />
            </div>
        ));

  const renderEnvironmentOverallHealthStatus = () => {
    const status = get(searchData, 'status', 'UNKNOWN');

    return searchData ? (
            <div className="health--environment-display-header">
                <label>Environment Status</label>
                <div className={`health--color-display-${formatClassNameStatus(status)}`} title={status} />
            </div>
    ) : (
            <div className="health--environment-display-header">
                <label>No Environment Health Data Found</label>
            </div>
    );
  };

  const renderEnvironmentFieldStatus = () => {
    if (searchData) {
      return map(searchData, (element, key) => {
        if (key !== 'status') {
          const field = key.charAt(0).toUpperCase() + key.slice(1);
          const status = get(element, 'status', 'UNKNOWN');

          return (
                        <div className="health--environment-status-field" key={`healthStatus${field}`}>
                            <label>{field}</label>
                            <div className={`health--color-display-${formatClassNameStatus(status)}`} title={status} />
                        </div>
          );
        }
      });
    }
  };

  const renderLegend = () => {
    const statuses = ['UP', 'DOWN', 'OUT_OF_SERVICE', 'IMPACTED', 'MISC', 'UNKNOWN'];
    return statuses.map((status) => (
            <div className="health--legend-item" key={`health-legend-item-label${status}`}>
                <div className={`health--color-display-${formatClassNameStatus(status)}`} />
                <label>{status}</label>
            </div>
    ));
  };

  return (
        <Permissions adminOnly={true} notAuthorizedMessage={true}>
            <ServicesRefreshPanelAction />
            <div className="health">
                <div className="health--legend">
                    <div className="health--legend-display">
                        <div className="health--legend-display-header">Status Key</div>
                        {renderLegend()}
                    </div>
                </div>
                {renderEnvironmentHealth()}
            </div>
        </Permissions>
  );
}

Health.propTypes = {
    fetching: PropTypes.bool,
    servicesSearchData: PropTypes.object,
};

export default withSearch(Health, servicesDataKey);
